import { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { Favorite } from '@mui/icons-material'
import dayjs from 'dayjs'
import { useCurrentUser } from '~/common/use-current-user'

export const AccountUpgradeCard = () => {
  const { currentUser } = useCurrentUser()
  const [fundHistory, setFundHistory] = useState([])
  const [loading, setLoading] = useState(false) // FIXME

  // TODO Billing > upgrade/fund history
  // useEffect(() => {
  //   if (!currentUser?.id) return
  //   async function fetchUpgrades() {
  //     setLoading(true)
  //     const { data } = await supabase
  //       .from('upgrades')
  //       .select('*')
  //       .eq('user_id', currentUser.id)
  //       .order('created_at', { ascending: false })
  //     setFundHistory(data ?? [])
  //     setLoading(false)
  //   }
  //   fetchUpgrades()
  // }, [currentUser?.id])

  const handleUpgrade = () => {
    window.open('https://terra-planner.com/support', '_blank', 'noopener,noreferrer')
  }

  return (
    <Card variant="outlined">
      <CardHeader
        title="Support Us"
        action={
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<Favorite />}
            onClick={handleUpgrade}
            sx={{ textTransform: 'none', mr: 1 }}
          >
            Support TerraPlanner
          </Button>
        }
        sx={{ pb: 0 }}
      />
      <CardContent>
        <Stack spacing={2}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' },
              columnGap: 2,
              rowGap: { xs: 0.5, md: 0 },
              alignItems: 'flex-start',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              TerraPlanner is built and maintained by a small team. Your support helps keep the lights on
              and new features coming. Every contribution is deeply appreciated.
            </Typography>
          </Box>

          {!loading && fundHistory.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              No funds on record yet. Consider supporting TerraPlanner to help fund our homesteads so we can fund yours!
            </Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Method</TableCell>
                  <TableCell>Note</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fundHistory.map((d) => (
                  <TableRow key={d.id}>
                    <TableCell>{dayjs(d.created_at).format('MMM D, YYYY')}</TableCell>
                    <TableCell>${(d.amount_cents / 100).toFixed(2)}</TableCell>
                    <TableCell>{d.method ?? '—'}</TableCell>
                    <TableCell>{d.note ?? '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}
